import React from "react"
import { ClickAwayListener, MenuItem, MenuList, Paper, Popper, Theme, Typography, makeStyles } from "@material-ui/core"

import { ChatParticipantResponse } from "../api/chat-response"

type Props = {
  anchorEl: HTMLElement | null
  members: ChatParticipantResponse[]
  activeIndex: number
  onSelect: (member: ChatParticipantResponse) => void
  onClose: () => void
}

const MentionPicker = ({ anchorEl, members, activeIndex, onSelect, onClose }: Props) => {
  const classes = useStyles()

  return (
    <Popper
      open={Boolean(anchorEl) && members.length > 0}
      anchorEl={anchorEl}
      placement="top-start"
      className={classes.popper}
      modifiers={{ preventOverflow: { boundariesElement: "viewport" } }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper className={classes.paper}>
          <MenuList dense disablePadding>
            {members.map((member, index) => (
              <MenuItem
                key={member.userId}
                selected={index === activeIndex}
                // On mousedown, so the composer keeps focus and the caret stays where the
                // mention is about to be written.
                onMouseDown={(event) => {
                  event.preventDefault()
                  onSelect(member)
                }}
              >
                <Typography className={classes.name}>{member.name}</Typography>
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      </ClickAwayListener>
    </Popper>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  popper: {
    zIndex: theme.zIndex.modal,
  },

  paper: {
    minWidth: 240,
    maxHeight: theme.spacing(30),
    overflowY: "auto",
  },

  name: {
    fontSize: 13,
    fontWeight: 600,
  },
}))

export default MentionPicker
